module.exports = __webpack_public_path__ + "img/login-img.4e7d4cc3.png";